import WaveHiComponent from "../../../../src/posts/08-2020-how-css-academy-was-created/WaveHiComponent";
import * as React from 'react';
export default {
  WaveHiComponent,
  React
};